<template lang="pug">
.app-panel(:class="panelClassName")
    header.app-panel-header
        slot(name="header")
    main.app-panel-content
        slot(name="content")
    footer.app-panel-footer(v-show="$slots.hasOwnProperty('footer')")
        slot(name="footer")
</template>

<script>
export default {
    name: 'Panel',
    props: {
        id: { type: String, required: false, default: '' },
        panelClassName: { type: String, required: true },
        titleIsEditable: { type: Boolean, required: false }
    }
}
</script>
